<template>
  <div class="wlx-site-manager-wrapper-1">
    <div class="yk-wrap-fixed clearfix">
      <div class="u-table-main">
        <el-table
          ref="multipleeeeTable"
          :data="list"
          tooltip-effect="dark"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
             <span v-if="scope.row.sex == 0">男</span>
             <span v-if="scope.row.sex == 1">女</span>
             </template>
          </el-table-column>
          <el-table-column prop="company" label="单位"></el-table-column>
          <el-table-column prop="job" label="职务/职称"></el-table-column>
          <el-table-column label="是否为原专委会委员">
              <template slot-scope="scope">
                  <span v-if="scope.row.isCommittee == 0">是</span>
                  <span v-if="scope.row.isCommittee == 1">否</span>
              </template>
          </el-table-column>
          <el-table-column label="委员会类型">
              <template slot-scope="scope">
                  <span>{{committee[scope.row.committeeType-1].label}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="phone" label="账号"></el-table-column>
          <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
              <el-button icon="el-icon-edit" size="mini" type="primary" @click="editTable(scope.row.id)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      committee:[
          {
              label:'教学改革专业委员会',
              value:1
          },
          {
              label:'技能开发专业委员会',
              value:2
          },
          {
              label:'校企合作专业委员会',
              value:3
          },
          {
              label:'国际合作专业委员会',
              value:4
          },
          {
              label:'信息化专业委员会',
              value:5
          },
          {
              label:'师资建设专业委员会',
              value:6
          },
      ],
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.getCommittemeList();
  },
  methods: {
    getCommittemeList(){
      this.$http
        .post("/api/XOrg/AssessmentApply/getCommitteeInfoById")
        .then(rst => {
          if (rst.code > 0) {
            this.list = rst.list;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    editTable(id){
       this.$router.push({
         name:'committeeEdit',
         params:{
           committeeId:id
         }
       });
    }
  }
};
</script>


<style lang='scss'>
.wlx-site-manager-wrapper-1 {
  .news-page-con {
    padding: 20px 0;
    text-align: center;
  }
  .d-search-form-news {
    margin: 13px 0px 0 0;
  }
  .ad-school-manager-head{
  
    width: calc(100% - 240px);
  
    text-align: right;
  }
}
</style>
